/* eslint-disable
    goodeggs/import-no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import './style';

angular
  .module(__filename, [
    'ui.router',

    require('goodeggs-employee-roles/lib/angular'),
    require('goodeggs-purchase-orders-sdk/product_type/angular_resource'),
    require('angular-klaxon').name,
    require('angular-directive-percentage'),
    require('local_modules/services/supplier').default,
    require('local_modules/services/producer').default,
    require('local_modules/services/product').default,
    require('local_modules/services/product_types').default,
    require('local_modules/filters/format_time').default.name,
    require('./dropoff_day_capacities').default,
    require('./dropoff_day_capacity_overrides').default,
  ])

  .config(
    ngInject(function($stateProvider) {
      $stateProvider.state('catalog.supplier.item', {
        url: '',
        abstract: true,
        template: '<ui-view></ui-view>',
      });

      $stateProvider.state('catalog.supplier.item.new', {
        url: '/new?notifyOnSave',
        template: require('./template'),
        controller: require('./controller').default,
        controllerAs: 'ctrl',
      });

      return $stateProvider.state('catalog.supplier.item.edit', {
        url: '/:catalogItemId',
        template: require('./template'),
        controller: require('./controller').default,
        controllerAs: 'ctrl',
      });
    }),
  );

export default __filename;
